import { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { AggregateEuRootRequest } from 'src/apis/aggregate-eu/use-aggregate-eu-root';
import { Stack } from 'src/components/layout/stack';
import { Heading } from 'src/components/text/heading';
import { Successful } from 'src/hooks/use-axios';
import { useTitle } from 'src/hooks/use-title';
import { MyDemands } from 'src/pages/aggregate-eu/demands/my-demands';
import { EditGasDemand } from 'src/pages/aggregate-eu/demands/my-demands/edit-gas-demand';
import { CreateGasDemand } from 'src/pages/aggregate-eu/demands/my-demands/submit-gas-demand';
import { DemandsTabNavigation } from 'src/pages/aggregate-eu/demands/my-demands/submit-gas-demand/components/demands-tab-navigation';
import { AggregateEuMyInformationSheets } from 'src/pages/aggregate-eu/demands/my-information-sheets';

type Params = {
  aggregateEuRootRequest: Successful<AggregateEuRootRequest>;
};

const AggregateEuDemandsPage: FC<Params> = ({ aggregateEuRootRequest }) => {
  useTitle('Demands');

  return (
    <Stack gap={2}>
      <Heading mode="title">Demands</Heading>
      <DemandsTabNavigation />
      <Switch>
        <Route exact path="/aggregate-eu/demands">
          <Redirect to="/aggregate-eu/demands/my-demands" />
        </Route>
        <Route path="/aggregate-eu/demands/my-demands/edit/:demandAtLocationId">
          <EditGasDemand aggregateEuRootRequest={aggregateEuRootRequest} />
        </Route>
        <Route path="/aggregate-eu/demands/my-demands/create">
          <CreateGasDemand aggregateEuRootRequest={aggregateEuRootRequest} />
        </Route>
        <Route exact path="/aggregate-eu/demands/my-demands">
          <MyDemands aggregateEuRootRequest={aggregateEuRootRequest} />
        </Route>
        <Route path="/aggregate-eu/demands/my-information-sheets">
          <AggregateEuMyInformationSheets
            aggregateEuRootRequest={aggregateEuRootRequest}
          />
        </Route>
      </Switch>
    </Stack>
  );
};

export default AggregateEuDemandsPage;
